



































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import AgreementForm from './agreement-form.vue';
import ChartLevels from './chart-levels.vue';
import ChartStatuses from './chart-statuses.vue';

class PageAgreementRequest extends PageRequest {
    year: any = parseInt(Util.abp.clock.today().substr(0, 4));
    dealer: number = null;
    red: number = null;
    zone: number = 1;
}

@Component({
    components: { ListView, AgreementForm, FormBase, ChartLevels, ChartStatuses },
    watch: {
        dealers: function (val) {
            (this as any).pagerequest.dealer = val;                
            (this as any).getpage();
        },
        red: function (val) {
            (this as any).pagerequest.red = val;
            (this as any).getpage();
        }
    }
})
export default class Agreements extends ListBase {
    entity: string = 'agreement';
    pagerequest: PageAgreementRequest = new PageAgreementRequest();
    filterForm: boolean = true;
    showDealers: boolean = false;
    widType: string = 'Venta';
    views: Array<any> = [{ code: "stats", title: "Ver Estadisticas", icon: "bar_chart" }];
    currentView: string = 'list';

    filterItems = [
        this.gItem({ type: 'object', prop: 'zone', label: 'Zona', entity: 'zone', size: 4, hideDetails: true, onchange: this.changeZone }),
        this.gItem({ type: 'object', prop: 'dealer', label: 'Concesionario', entity: 'dealer', itemText: 'fullname', hideDetails: true, size: 4, filterParam: 'zone_id', filterVal: [this.pagerequest.zone], onchange: this.getpage }),
        this.gItem({ type: 'select', prop: 'year', label: 'Anio', options: 'years', hideDetails: true, onchange: this.getpage, size: 4 }),
    ]

    columns = [
        this.gCol('dealer.fullname', 'Concesionario', 'text'),
        this.gColO({ type: 'text', value: 'reason', text: 'Motivo' }),
        this.gCol('description', 'Punto a tratar', 'text'),
        this.gColO({ type: 'list', value: 'employees_names', text: 'Responsables' }),
        this.gCol('agreement_date', 'Fecha Acuerdo', 'date'),
        this.gCol('days', 'Plazo (dias)', 'text'),
        this.gCol('due_date', 'Fecha venc', 'date'),
        this.gCol('days_remain', 'Dias restantes', 'text'),            
        this.gColO({ type: 'chip', value: 'state_calc', text: 'Estado', color: 'extra', generalType: true }),
        this.gColO({ type: 'chip', value: 'level_id', text: 'Nivel de cumplimiento', color: 'extra', generalType: true }),
        this.defaultActions()
    ]

    get title() {
        let zone = Util.getEntity(this, 'zone', this.pagerequest.zone);
        return 'Seguimiento de Protocolos' + (zone != null ? ' - '  + zone.name : '');
    }
    
    get dealers() {
        return this.$store.state.app.dealers;
    }

    get red() {
        return this.$store.state.app.red;
    }

    get loading() {
        return this.$store.state.agreement.loading;
    }

    get isDealer() {
        return Util.abp.session.isDealer();
    }

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }

    changeZone(id) {
        this.setItem(this.filterItems, 'dealer', 'filterVal', [id]);
        this.getpage();
    }
    
    async getpage() {
        let list: any = this.$refs.listView
        if (list != undefined) 
            await list.getpage();
        
        if (this.$refs.lev != undefined) 
            await (this.$refs.lev as any).loadData();

        if (this.$refs.sta != undefined)
            await (this.$refs.sta as any).loadData();
    }

    async sendNoty() {
        await this.$store.dispatch({
            type: 'agreement/sendNoty'
        });
    }

    mounted() {
        this.setItem(this.filterItems, 'zone', 'disabled', this.isDealer);
        this.setItem(this.filterItems, 'dealer', 'disabled', this.isDealer);
    }

    created() {
        this.pagerequest.dealer = null;
        if (this.dealers != null && this.dealers.length > 0)
            this.pagerequest.dealer = this.dealers[0];

        let deal = Util.getEntity(this, 'dealer', this.pagerequest.dealer);
        
        if (deal != null) {
            this.pagerequest.zone = deal.zone_id;
            this.setItem(this.filterItems, 'dealer', 'filterVal', [this.pagerequest.zone]);
        }

        
    }
}